/**
 * 长图「改这一块」里 AI 改图 / AI 重画 的亮价参数(修复波 0926 第三批 · 代理 H)。
 *
 * ★计价口径是**读后端核出来的**,不是照海报单图重生抄的(只读快照 = api 0b810d33 / ai 682a56a6):
 *   · api `PosterService.regenerateLongImageBlock`:余额闸 `check(provider, tier, 1)` —— 按 **1 张**;
 *     provider = 整包顶层 `provider`(缺省 OPENAI),tier = `canvas.scale` 1/2/3 → 1K/2K/4K(缺省 2K)
 *     (`PosterCreditPrecheck.longImageProvider / longImageTier`)。
 *   · ai `longimage/orchestrator._run_regen`:只有目标图块走 `_generate_image_block` → 一次
 *     `_record_gen_billing`(「唯一一笔出图计费」);其余块复用旧分段或 PIL 重渲,不计费。
 *     票是 `action_type=longimage_render`、`action_id={taskId}:rb:{regenId}`。
 *   · 结算:该端点**不收 quoteId**,没有单 → `resolveByActionType` → SKU `longimage.render`,
 *     `ImageTierSettlePricer` 按 (model, tier) 反查变体、qty = 1 → `priceOf(longimage.render, 变体, 1)`。
 *   所以亮的价 = `longimage.render` × `{provider}_{tier}` × 1,与实扣同一条 priceOf。
 *
 * ★只亮价、不开单:后端这个口没有绑单入参,前端开了单也绑不上(白占一张单)。要「报价即合同」
 *   得先让 api 收 quoteId 并绑到 `{taskId}:rb:{regenId}` —— 那是 api 的活,不在这里做。
 */
import type { QuoteParams } from "@/entities/pricing/api/pricingService";
import { SKU, imageVariant } from "@/entities/pricing/model/priceBook";

import { tierOfScale } from "../../model/longImageEstimate";

/** 与 api `LONG_IMAGE_DEFAULT_PROVIDER` / ai `LongImageRequest.provider` 默认同值。 */
const LONG_IMAGE_DEFAULT_PROVIDER = "OPENAI";

/**
 * @param spec 这一稿真正发给引擎的整包(`readLongImageSpec` → `useLongImageSpec().raw`);
 *   没拿到 → null(不亮价,也不猜)。
 */
export function longImageBlockRegenQuoteParams(
  spec: Record<string, unknown> | null | undefined
): QuoteParams | null {
  if (!spec) return null;
  const p = spec.provider;
  const provider = typeof p === "string" && p.trim() ? p : LONG_IMAGE_DEFAULT_PROVIDER;
  const canvas = spec.canvas;
  const scale =
    canvas &&
    typeof canvas === "object" &&
    typeof (canvas as { scale?: unknown }).scale === "number"
      ? (canvas as { scale: number }).scale
      : 2;
  return {
    skuCode: SKU.longImage,
    variantKey: imageVariant(provider, tierOfScale(scale)),
    qty: 1,
  };
}
